import { apiUrl, InitiateResponse, spawnErrorOverlay } from "../common";
import * as pdfjsLib from "pdfjs-dist";
import pdfWorker from "/pdf.worker.min.mjs?url";

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorker;

export class PdfPlayer {
    private pageContainerElement: HTMLDivElement;
    private statusBageElement: HTMLDivElement;
    private pdfDocument: pdfjsLib.PDFDocumentProxy | null = null;
    private url: string;
    private loadedCount = 0;

    private updateStatusBadge() {
        const totalPages = this.pdfDocument?.numPages;
        if (!this.pdfDocument) {
            this.statusBageElement.innerText = "Document is loading";
            return;
        }

        const loadedPages = this.loadedCount;
        const full = loadedPages === totalPages;
        if (full) {
            this.statusBageElement.innerText = "Document is ready";
            return;
        }
        this.statusBageElement.innerText = `${loadedPages}/${totalPages} pages loaded`;
    }

    public constructor(data: InitiateResponse, socket: HTMLDivElement) {
        this.pageContainerElement = document.createElement("div");
        this.pageContainerElement.id = "pdf-player";

        this.statusBageElement = document.createElement("div");
        this.statusBageElement.id = "pdf-player-status-badge";

        this.url = `${apiUrl}/protected/play/${data.encryptedPlayPayload}/default`;

        socket.appendChild(this.pageContainerElement);
        socket.appendChild(this.statusBageElement);
        this.loadPdf();
        this.updateStatusBadge();

        //     fm.onPlayerReady();
    }

    private async loadPdf() {
        console.log("Loading PDF");
        try {
            this.pdfDocument = await pdfjsLib.getDocument(this.url).promise;
        } catch (e) {
            spawnErrorOverlay(
                JSON.stringify({
                    error: "Failed to load Document",
                    details: e,
                })
            );
            return;
        }

        this.updateStatusBadge();
        console.log("PDF loaded");
        for (let i = 1; i <= this.pdfDocument.numPages; i++) {
            this.renderPage(i);
        }
    }

    private async renderPage(pageNumber: number) {
        console.log("Rendering page");
        if (!this.pdfDocument) {
            spawnErrorOverlay("PDF document not loaded");
            throw new Error("PDF document not loaded");
        }
        const page = await this.pdfDocument.getPage(pageNumber);
        const scale = 1.5;
        const viewport = page.getViewport({ scale });

        const canvas = document.createElement("canvas");
        canvas.height = viewport.height;
        canvas.width = viewport.width;
        this.pageContainerElement.appendChild(canvas);

        const context = canvas.getContext("2d");
        if (!context) {
            spawnErrorOverlay("Failed to get canvas context");
            throw new Error("Failed to get canvas context");
        }

        const renderContext = {
            canvasContext: context,
            viewport,
        };
        await page.render(renderContext).promise;
        this.loadedCount++;
        this.updateStatusBadge();
        console.log(`Page ${pageNumber} rendered`);
    }
}
